import { decryptText } from '@/utils/crypto'

const users = [
  {
    id: 0,
    name: '超级管理员',
    username: 'admin',
    password: '123456',
    roles: ['admin'],
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  },
  {
    id: 1,
    name: '管理员',
    username: 'editor',
    password: '123456',
    roles: ['editor'],
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  },
  {
    id: 99,
    name: '普通用户',
    username: 'user',
    password: '123456',
    roles: ['user'],
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  },
  {
    id: 100,
    name: '张三',
    username: 'zhangsan',
    password: '123456',
    roles: ['editor', 'user'],
    avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  },
]

export function login(params = {}) {
  const { username, password } = params
  const _username = decryptText(username)
  const _password = decryptText(password)

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const userData = users.find(item => item.username === _username)

      if (!userData) {
        reject({
          success: false,
          message: '用户不存在',
        })
        return
      }
      if (userData.password !== _password) {
        reject({
          success: false,
          message: '密码不正确',
        })
        return
      }

      resolve({
        success: true,
        message: '登录成功',
        data: userData,
      })
    }, 500)
  })
}

export function getUsers(params = {}) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        data: users,
        total: users.length,
      })
    }, 500)
  })
}
